import React from 'react';
import _get from 'lodash/get';

import { useLang, useMediaConfig } from 'bdvp-common/src/hooks/config';
import { MEDIA_CONFIG_CONTEXT } from 'bdvp-common/src/utils/constants';

import MessageComponent from '../components/Message';

const defaultMessage = {
    title: '',
    body: '',
};

const Message = ({
    type,
}) => {

    const lang = useLang();
    const config = useMediaConfig(MEDIA_CONFIG_CONTEXT.search);
    const message =  _get(config, `messages.${type}.${lang}`, defaultMessage);

    return (
        <MessageComponent
            message={message}
        />
    );

};

export default Message;
